import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'discountVipFilter'
})
export class DiscountVipFilterPipe implements PipeTransform {
  transform(price: any, client?: any, prod?: any): any {
    let newVal: any = price;
    if (client && client.id_group) {
      if (client.discount) {
        newVal = price * ((100 - client.discount) / 100)
      }
      if (client.groups_discount && client.groups_discount.length > 0 && prod && prod.rubric) {
        // prod.rubric.id
        let discount_prod_rubric = client.groups_discount.find((value: any) => value.id_rubric == prod.rubric.id);
        if (discount_prod_rubric) {
          newVal = price * ((100 - discount_prod_rubric.discount) / 100)
        }
      }
    }
    return  Math.round(parseFloat(newVal) * 100) / 100;
  }
}
